import { render, staticRenderFns } from "./ClubProphet.vue?vue&type=template&id=749ad94b&scoped=true"
import script from "./ClubProphet.vue?vue&type=script&lang=js"
export * from "./ClubProphet.vue?vue&type=script&lang=js"
import style0 from "./ClubProphet.vue?vue&type=style&index=0&id=749ad94b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749ad94b",
  null
  
)

export default component.exports